export const COLORS = [
  'rgba(88, 145, 247, 1)',
  'rgba(245, 189, 67, 1)',
  'rgba(109, 205, 250, 1)',
  'rgba(242, 166, 230, 1)',
]
